import React from "react";
import GoogleSSOButton from "../sso/providers/GoogleSSOButton";
import useLoginBoxLogic from "../hooks/useLoginBoxLogic";

const LoginBoxContent = ({
  onLoginSuccess,
  loginContext = null,
  className = "login-box",
  showLogo = true,
  showTitle = true,
}) => {
  const {
    formData,
    error,
    successMessage,
    showPassword,
    passwordExpired,
    setShowPassword,
    handleInputChange,
    handleSubmit,
  } = useLoginBoxLogic({ onLoginSuccess });

  return (
    <div className={className}>
      {showLogo && (
        <img
          src="/images/locapp7_large.png"
          alt="LocApp logo"
          className="login-logo"
        />
      )}
      {showTitle && <h2>{passwordExpired ? "Change Password" : "Login"}</h2>}

      {(loginContext?.reason === "private_resource" ||
        loginContext?.reason === "share_open") &&
        !passwordExpired && (
        <div className="login-info-banner">
          {loginContext.reason === "private_resource"
            ? `This shared ${loginContext.resourceType || "item"} is private. Sign in if you have access.`
            : `Sign in to open this shared ${loginContext.resourceType || "item"} in your LocApp account.`}
        </div>
      )}

      {error && <div className="login-error">{error}</div>}
      {successMessage && <div className="login-success">{successMessage}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="field-label-stacked">Username</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
            required
            disabled={passwordExpired}
          />
        </div>

        <div className="form-group">
          <label className="field-label-stacked">{passwordExpired ? "Current Password" : "Password"}</label>
          <div className="password-input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
              disabled={passwordExpired}
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i
                className={`fi ${
                  showPassword ? "fi-rr-eye" : "fi-rr-eye-crossed"
                }`}
              ></i>
            </button>
          </div>
        </div>

        {passwordExpired && (
          <>
            <div className="form-group">
              <label className="field-label-stacked">New Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label className="field-label-stacked">New Password (Confirm)</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
          </>
        )}

        <button type="submit">
          {passwordExpired ? "Change Password" : "Sign In"}
        </button>
        <GoogleSSOButton />
      </form>
    </div>
  );
};

export default LoginBoxContent;
